"use client";

import { AppPageTitle } from "@/widgets";
import WebSection from "@/widgets/app/page/web/WebSection";
import { SsgoiTransition } from "@ssgoi/react";

export default function WebPage() {
  return (
    <SsgoiTransition id="/app/pages/web">
      <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
        <AppPageTitle />
      </div>

      <div className="w-full flex-col">
        {/* 메인  */}
        <WebSection />
      </div>
    </SsgoiTransition>
  );
}
